'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactReSuperTabs = require('react-re-super-tabs');





var _reactRouter = require('react-router');
var _connect = require('react-redux/lib/connect/connect');var _connect2 = _interopRequireDefault(_connect);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxPagan = require('redux-pagan');
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _userAuthentication = require('../../redux/modules/userAuthentication');



var _registrationLogo = require('../../../static/images/registrationLogo.png');var _registrationLogo2 = _interopRequireDefault(_registrationLogo);
var _containers = require('../../containers');
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _checkers = require('../../utils/checkers');
var _constants = require('../../constants');
var _MouseFlowService = require('../../services/MouseFlowService');var _MouseFlowService2 = _interopRequireDefault(_MouseFlowService);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _constants2 = require('./constants');
var _ModalError = require('./ModalError/ModalError');var _ModalError2 = _interopRequireDefault(_ModalError);
var _UserAuthenticationPage = require('./UserAuthenticationPage.scss');var styles = _interopRequireWildcard(_UserAuthenticationPage);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
var
UserAuthenticationPage = function (_React$Component) {_inherits(UserAuthenticationPage, _React$Component);function UserAuthenticationPage() {var _temp, _this, _ret;_classCallCheck(this, UserAuthenticationPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.
    state = {
      isFailModal: false }, _this.



































    closeFailModal = function () {return _this.setState({ isFailModal: false });}, _this.
    openFailModal = function () {return _this.setState({ isFailModal: true });}, _this.

    handleClick = function (type) {return function (event) {
        _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/' + type));
        var hiddenElement = event.currentTarget;
        hiddenElement.scrollIntoView({ block: 'nearest', behavior: 'smooth', inline: 'center' });
      };}, _this.

    customTab = function (type) {return function (event) {return (
          _react2.default.createElement('span', {
              onClick: _this.handleClick(type),
              style: event.isActive ? _constants2.styleActiveTab : _constants2.styleTab,
              className: styles.tab },

            event.children));};}, _temp), _possibleConstructorReturn(_this, _ret);}UserAuthenticationPage.prototype.componentDidMount = function componentDidMount() {var locale = this.props.locale;if (!!this.props.userToken) {_reactRouter.browserHistory.push((0, _appendLocale2.default)(locale, '/profile/edit'));}};UserAuthenticationPage.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var userData = newProps.userAuthentication;var _props$userAuthentica = this.props.userAuthentication,userIsAuthorized = _props$userAuthentica.userIsAuthorized,error = _props$userAuthentica.error;if (userData.error && userData.error !== error) {this.openFailModal();}if (userData && userData.userIsAuthorized && userData.userIsAuthorized !== userIsAuthorized) {_reactRouter.browserHistory.push((0, _appendLocale2.default)(this.props.locale, '/profile/edit'));if (userData.data) {_constants.storage.value.setItem('userData', JSON.stringify(userData.data));(0, _analyticsManager.setData)({ userId: userData.data.id });(0, _analyticsManager.setData)({ dimension1: userData.data.is_agent ? 'realtor' : 'regular' });}if ((0, _checkers.isTemporaryEmail)(userData.data.email)) {this.props.openAuthenticationModal({ bodyType: _constants.authenticationModalType.UPDATE_TEMPORARY_PROFILE }).then(function () {_MouseFlowService2.default.initialize().then(function () {_MouseFlowService2.default.startRecording();_MouseFlowService2.default.tagRecord(_constants.authenticationModalType.UPDATE_TEMPORARY_PROFILE);});});}}};UserAuthenticationPage.prototype.



  render = function render() {var _props =
    this.props,translate = _props.translate,selectedTab = _props.selectedTab;

    return (
      _react2.default.createElement('div', { className: styles.wrapper },
        _react2.default.createElement('div', null,
          _react2.default.createElement('div', { className: styles.userAuthenticationContent },
            _react2.default.createElement('p', { className: styles.title }, translate('authenticationPage', 'welcome')),
            _react2.default.createElement('div', { className: styles.tabsWrapper },
              _react2.default.createElement(_reactReSuperTabs.Tabs, { activeTab: (0, _get2.default)(this.props, 'routeData.location') || _constants.userAuthenticationPageTabs.SIGN_IN },
                _react2.default.createElement(_reactReSuperTabs.TabList, { id: 'authenticationTabList', className: styles.tabs },
                  _react2.default.createElement(_reactReSuperTabs.Tab, {
                    component: this.customTab(_constants.userAuthenticationPageTabs.SIGN_UP),
                    label: translate('authenticationPage', 'registration'),
                    id: _constants.userAuthenticationPageTabs.SIGN_UP }),

                  _react2.default.createElement(_reactReSuperTabs.Tab, {
                    component: this.customTab(_constants.userAuthenticationPageTabs.SIGN_IN),
                    label: translate('authenticationPage', 'login'),
                    id: _constants.userAuthenticationPageTabs.SIGN_IN })),


                _react2.default.createElement(_reactReSuperTabs.TabList, null,
                  _react2.default.createElement(_reactReSuperTabs.TabPanel, { component: _containers.RegistrationContainer, id: _constants.userAuthenticationPageTabs.SIGN_UP }),
                  _react2.default.createElement(_reactReSuperTabs.TabPanel, { component: _containers.loginContainer, id: _constants.userAuthenticationPageTabs.SIGN_IN }))))),




          _react2.default.createElement(_ModalError2.default, {
            isRtl: this.props.isRtl,
            isOpen: this.state.isFailModal,
            translate: translate,
            error: this.props.userAuthentication.error,
            onRequestClose: this.closeFailModal })),


        _react2.default.createElement('div', { className: styles.logo },
          _react2.default.createElement('img', { src: _registrationLogo2.default, alt: '' }))));



  };return UserAuthenticationPage;}(_react2.default.Component);


UserAuthenticationPage.propTypes = {
  translate: _propTypes2.default.func,
  openAuthenticationModal: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  userToken: _propTypes2.default.string,
  selectedTab: _propTypes2.default.string,
  authenticationModalType: _propTypes2.default.string,
  userAuthentication: _propTypes2.default.object,
  routeData: _propTypes2.default.object,
  switchAuthModalType: _propTypes2.default.func,
  routeParams: _propTypes2.default.object };


var mapDispatchToProps = {
  openAuthenticationModal: _userAuthentication.openAuthenticationModal,
  switchAuthModalType: _userAuthentication.switchAuthModalType };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    isRtl: (0, _checkRtlLanguage2.default)(state.lang.locale),
    userAuthentication: state.userAuthentication,
    selectedTab: state.userAuthentication.selectedTab,
    authenticationModalType: state.userAuthentication.authenticationModalType,
    userToken: (0, _get2.default)(state.userAuthentication, 'data.access_token'),
    locale: state.lang.locale };};exports.default =


(0, _connect2.default)(mapStateToProps, mapDispatchToProps)(UserAuthenticationPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/UserAuthenticationPage/UserAuthenticationPage.js
// module id = 3074
// module chunks = 0